// e.g /companies
const baseRouteRegex = /^\/companies/;

// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065
const companiesRouteRegex = new RegExp(
  baseRouteRegex.source + /\/[a-zA-Z0-9-]+/.source,
);

// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/profile
const companyProfileRouteRegex = new RegExp(
  companiesRouteRegex.source + /\/profile$/.source,
);

// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065
const dashboardRouteRegex = new RegExp(companiesRouteRegex.source + /$/.source);

// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/jobs
const baseJobsRouteRegex = new RegExp(
  companiesRouteRegex.source + /\/jobs/.source,
);
// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/jobs
const jobsRoutesRegex = new RegExp(baseJobsRouteRegex.source + /$/.source);
// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/jobs/create
const jobsCreateRouteRegex = new RegExp(
  baseJobsRouteRegex.source + /\/create$/.source,
);
// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/jobs/7d116c05-5448-4b30-98f8-e199dd7758b6
const jobsShowRouteRegex = new RegExp(
  baseJobsRouteRegex.source + /\/[a-zA-Z0-9-]+$/.source,
);

// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/jobs/7d116c05-5448-4b30-98f8-e199dd7758b6/pipeline
const jobsPipelineRouteRegex = new RegExp(
  baseJobsRouteRegex.source + /\/[a-zA-Z0-9-]+\/pipeline$/.source,
);

// e.g /companies/f75ab22e-1017-45f1-8c6d-118d68786065/jobs/<jobId>/pipeline with a specific <jobId>
const getSpecificJobPipelineRouteRegex = (jobId: string) =>
  new RegExp(baseJobsRouteRegex.source + `/${jobId}/pipeline$`);

export const routes = {
  isCompanyProfileRouteActive: (pathname: string) => {
    return companyProfileRouteRegex.test(pathname);
  },
  isDashboardRouteActive: (pathname: string) => {
    return dashboardRouteRegex.test(pathname);
  },
  isJobsRouteActive: (pathname: string) =>
    jobsRoutesRegex.test(pathname) ||
    jobsCreateRouteRegex.test(pathname) ||
    jobsShowRouteRegex.test(pathname),
  isJobsPipelineRouteActive: (pathname: string) =>
    jobsPipelineRouteRegex.test(pathname),
  isSpecificJobPipelineRouteActive: (pathname: string, jobId: string) =>
    getSpecificJobPipelineRouteRegex(jobId).test(pathname),
  isAnyJobInListPipelineRouteActive: (pathname: string, jobIds: string[]) =>
    jobIds.some((jobId) =>
      getSpecificJobPipelineRouteRegex(jobId).test(pathname),
    ),
};
